import cn from 'classnames';
import Image from 'next/image';
import React from 'react';

import WithGradientBorder from 'components/basic/WithGradientBorder';
import s from 'components/complex/payments/PaymentForm/SavedWallets/SavedWallets.module.scss';

import type { PaymentMethodType } from 'redux-store/slices/paymentsMethods/types';

interface Props {
  method: PaymentMethodType;
  isSelected: boolean;
  onClick: () => void;
}

export default function Wallet({
  method,
  isSelected,
  onClick,
}: Props): JSX.Element {
  const {
    id,
    card: { brand, last4, exp_year, exp_month },
  } = method;

  return (
    <WithGradientBorder
      isSelected={isSelected}
      key={id}
      onClick={onClick}
      className={cn([
        'cy-saved-card',
        s.card,
        // {
        //   [styles.selectedItem]: selectedCardId === id,
        // },
      ])}
    >
      <div className={s.topWrapper}>
        <Image
          width={28}
          height={20}
          src={`/pagesImages/payments/PlansPage/paymentsSystems/${brand}.png`}
        />

        <span className={s.date}>
          {exp_month}/{exp_year}
        </span>
      </div>
      <div className={s.lastDigits}>** {last4}</div>
    </WithGradientBorder>
  );
}
